const extensions = state => state.extensions
const groups = state => state.groups
const locations = state => state.locations
const mailboxes = state => state.mailboxes
const menus = state => state.menus
const numbers = state => state.numbers
const devices = state => state.devices
const recordings = state => state.recordings
const routingProfiles = state => state.routingProfiles
const schedules = state => state.schedules
const users = state => state.users

export default {
  extensions,
  groups,
  locations,
  mailboxes,
  menus,
  numbers,
  devices,
  recordings,
  routingProfiles,
  schedules,
  users,
}
